const translations = {
  de: {
    // Navigation
    'nav.currentTournaments': 'Aktuelle Turniere',
    'nav.presentationView': 'Presentation View',
    'nav.pastTournaments': 'Vergangene Turniere',
    'nav.adminLogin': 'Admin Login',
    'nav.adminArea': 'Admin Bereich',
    'nav.myProfile': 'Mein Profil',
    'nav.bracket': 'Turnierbaum/Ergebnisse eintragen',
    'nav.bracketShort': 'Ergebnisse',
    'nav.editTournament': 'Turnier bearbeiten',
    'nav.editShort': 'Bearbeiten',
    'nav.createTournament': 'Turnier erstellen',
    'nav.createShort': 'Erstellen',
    'nav.deleteTournament': 'Turnier löschen',
    'nav.deleteShort': 'Löschen',
    'nav.userManagement': 'Benutzerverwaltung',
    'nav.usersShort': 'Benutzer',
    'nav.systemSettings': 'System-Einstellungen',
    'nav.settingsShort': 'Einstellungen',
    'nav.activityLog': 'Aktivitäts-Log',
    'nav.logout': 'Logout',
    'nav.menu': 'Menu',
    'nav.close': 'Schließen',
    'nav.tournaments': 'Turniere',
    'nav.archive': 'Archiv',
    'nav.presentation': 'Presentation',
    'nav.login': 'Login',

    // Common
    'common.loading': 'Lade...',
    'common.loadingData': 'Lade Daten...',
    'common.error': 'Fehler',
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.create': 'Erstellen',
    'common.close': 'Schließen',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'common.confirm': 'Bestätigen',
    'common.back': 'Zurück',
    'common.teams': 'Teams',
    'common.courts': 'Courts',
    'common.finished': 'Beendet',
    'common.open': 'Offen',
    'common.bye': 'Bye',
    'common.round': 'Runde',
    'common.note': 'Notiz',
    'common.notePlaceholder': 'z.B. Aufgabe wegen Verletzung...',
    'common.points': 'Punkte',
    'common.rank': 'Platz',
    'common.name': 'Name',
    'common.date': 'Datum',
    'common.noData': 'Keine Daten vorhanden.',
    'common.poweredBy': 'powered by',
    'common.activate': 'Aktivieren',
    'common.deactivate': 'Deaktivieren',
    'common.remove': 'Entfernen',

    // Admin Bracket View
    'admin.loadingTournament': 'Lade Turnier-Daten...',
    'admin.searchTournament': '🔍 Turnier suchen:',
    'admin.searchPlaceholder': 'Nach Name oder Datum suchen...',
    'admin.selectTournament': 'Turnier auswählen:',
    'admin.selectDefault': '-- Bitte Turnier auswählen --',
    'admin.activeTournaments': '🟢 Aktive Turniere',
    'admin.inactiveTournaments': '⚪ Inaktive Turniere',
    'admin.finishTournament': '🏆 Turnier beenden & Rangliste anzeigen',
    'admin.finishing': 'Wird beendet...',
    'admin.saveResult': 'Ergebnis speichern',
    'admin.saveCourtOnly': 'Nur Zeit/Court speichern',
    'admin.saveCourt': 'Zeit/Court speichern',
    'admin.tournamentCompleted': 'Turnier beendet',
    'admin.tournamentFinished': 'Turnier abgeschlossen',
    'admin.generating': 'Generiere...',
    'admin.generateNextRound': 'Nächste Runde ({n}) generieren',
    'admin.createBracket': 'Bracket erstellen',
    'admin.creatingBracket': 'Erstelle Bracket…',
    'admin.seedTeamsRemaining': 'Noch {n} Team(s) setzen',
    'admin.matchFinished': '✓ Beendet',
    'admin.matchRunning': '▶ Läuft',
    'admin.matchOpen': '○ Offen',
    'admin.editCourtTime': 'Platz / Uhrzeit bearbeiten',
    'admin.editModalTitle': 'Platz / Uhrzeit / Notiz',
    'admin.courtLabel': '🏟️ Platz / Court',
    'admin.courtPlaceholder': 'z.B. Court 1',
    'admin.timeLabel': '⏰ Startzeit',
    'admin.endTime': 'Endzeit:',
    'admin.noteLabel': '📝 Notiz (nur für Admins)',
    'admin.set1': 'Satz 1',
    'admin.set2': 'Satz 2',
    'admin.tiebreak': 'Tiebreak',
    'admin.tiebreakHint': 'Tiebreak nur bei Satzstand 1:1',
    'admin.onlyIfTied': 'nur bei Satzstand 1:1',
    'admin.pointsTeam1': 'Punkte Team 1',
    'admin.pointsTeam2': 'Punkte Team 2',
    'admin.errorEnterBothScores': 'Bitte beide Ergebnisse eingeben',
    'admin.errorEnterSets': 'Bitte mindestens Satz 1 und 2 eingeben',
    'admin.noDate': 'Kein Datum',
    'admin.invalidDate': 'Ungültiges Datum',
    'admin.timeHeader': 'Uhrzeit',
    'admin.matchHeader': 'Spiel',
    'admin.statusHeader': 'Status',
    'admin.tipClickMatch': '💡 Tipp: Klicken Sie auf ein Spiel, um zur Gruppenphase zu springen und das Ergebnis einzutragen.',

    // Tournament type labels
    'type.ko': 'KO-Turnier',
    'type.groups': 'Gruppenphase',
    'type.mexicano': 'Mexicano',
    'type.americano': 'Americano',
    'type.ko_placement': 'KO+Monrad',

    // Round names
    'round.final': 'Finale',
    'round.semifinal': 'Halbfinale',
    'round.quarterfinal': 'Viertelfinale',
    'round.thirdPlace': 'Spiel um Platz 3',
    'round.winnerOf': 'Sieger',
    'round.loserOf': 'Verlierer',

    // Current Tournament page
    'currentTournament.title': 'Aktuelle Turniere',
    'currentTournament.loading': 'Lade Turnierdaten...',
    'currentTournament.noTournaments': 'Derzeit sind keine aktiven Turniere vorhanden.',
    'currentTournament.loadError': 'Fehler beim Laden der Turniere.',

    // Past Tournaments page
    'pastTournaments.title': 'Vergangene Turniere',
    'pastTournaments.loading': 'Lade Turnierdaten...',
    'pastTournaments.noTournaments': 'Bisher sind keine vergangenen Turniere gespeichert.',
    'pastTournaments.loadError': 'Fehler beim Laden der Turniere.',

    // Tournament Detail page
    'tournamentDetail.loading': 'Lade Turnierdaten...',
    'tournamentDetail.notFound': 'Turnier nicht gefunden.',
    'tournamentDetail.loadError': 'Fehler beim Laden der Turnierdaten.',
    'tournamentDetail.details': 'Turnier Details',
    'tournamentDetail.backToOverview': '← Zurück zur Übersicht',
    'tournamentDetail.tab.matches': 'Spielverlauf',
    'tournamentDetail.tab.standings': 'Tabelle',
    'tournamentDetail.tab.teams': 'Teams',
    'tournamentDetail.set': 'Satz',
    'tournamentDetail.finished': '✓ Beendet',
    'tournamentDetail.done': '✓ Fertig',
    'tournamentDetail.inTournament': 'Im Turnier',
    'tournamentDetail.standings': 'Rangliste',
    'tournamentDetail.liveStandings': 'Live-Tabelle',
    'tournamentDetail.currentPlacements': 'Aktuelle Platzierungen',
    'tournamentDetail.finalRankings': '🏆 Endgültige Rangliste',
    'tournamentDetail.mainBracket': '🏆 Hauptbaum',
    'tournamentDetail.places5to8': '5.–8. Platz',
    'tournamentDetail.places9to16': '9.–16. Platz',
    'tournamentDetail.placement': 'Platzierung',
    'tournamentDetail.rank': 'Platz',
    'tournamentDetail.player': 'Spieler / Team',
    'tournamentDetail.wins': 'S',
    'tournamentDetail.losses': 'N',
    'tournamentDetail.draws': 'U',
    'tournamentDetail.pts': 'Pkt.',
    'tournamentDetail.sets': 'Sätze',
    'tournamentDetail.diff': 'Dif.',
    'tournamentDetail.setsWon': 'Sätze+',
    'tournamentDetail.setsLost': 'Sätze-',
    'tournamentDetail.setsDiff': 'Satzdiff.',
    'tournamentDetail.gamesWon': 'Spiele+',
    'tournamentDetail.gamesLost': 'Spiele-',
    'tournamentDetail.gamesDiff': 'Spieldiff.',
    'tournamentDetail.noTeams': 'Keine Teams.',
    'tournamentDetail.noMatches': 'Noch keine Matches.',
    'tournamentDetail.knockoutPhase': 'Finalrunden',
    'tournamentDetail.placementMatches': 'Platzierungsspiele',
    'tournamentDetail.schedule': '⏰ Zeitplan anzeigen',
    'tournamentDetail.viewSchedule': '⏰ Zeitplan anzeigen',
    'tournamentDetail.realtime': 'Live-Updates aktiv',

    // Admin Login
    'adminLogin.title': 'Admin Login',
    'adminLogin.username': 'Benutzername',
    'adminLogin.password': 'Passwort',
    'adminLogin.submit': 'Einloggen',
    'adminLogin.loading': 'Login läuft...',
    'adminLogin.error': 'Login fehlgeschlagen. Bitte Zugangsdaten prüfen.',

    // User Profile
    'userProfile.title': 'Mein Profil',
    'userProfile.username': 'Username',
    'userProfile.firstName': 'Vorname',
    'userProfile.lastName': 'Nachname',
    'userProfile.email': 'Email',
    'userProfile.role': 'Rolle',
    'userProfile.createdAt': 'Konto erstellt am',
    'userProfile.editProfile': 'Profil bearbeiten',
    'userProfile.changePassword': 'Passwort ändern (optional)',
    'userProfile.passwordHint': 'Lassen Sie diese Felder leer, wenn Sie das Passwort nicht ändern möchten.',
    'userProfile.newPassword': 'Neues Passwort',
    'userProfile.confirmPassword': 'Passwort bestätigen',
    'userProfile.passwordMismatch': 'Passwörter stimmen nicht überein',
    'userProfile.saveSuccess': 'Profil erfolgreich aktualisiert',
    'userProfile.loading': 'Lade Profil...',
    'role.user': 'Benutzer',
    'role.tournament_admin': 'Turnier Admin',
    'role.full_admin': 'Full Admin',

    // Tournament Create/Edit
    'tournamentForm.createTitle': 'Neues Turnier erstellen',
    'tournamentForm.editTitle': 'Turnier bearbeiten',
    'tournamentForm.name': 'Turniername',
    'tournamentForm.type': 'Turniertyp',
    'tournamentForm.date': 'Datum',
    'tournamentForm.teams': 'Anzahl Teams',
    'tournamentForm.courts': 'Anzahl Courts',
    'tournamentForm.description': 'Beschreibung',
    'tournamentForm.active': 'Aktiv',
    'tournamentForm.submit': 'Erstellen',
    'tournamentForm.update': 'Speichern',

    // Tournament Delete
    'tournamentDelete.title': 'Turnier löschen',
    'tournamentDelete.confirm': 'Sicher löschen?',
    'tournamentDelete.success': 'Turnier erfolgreich gelöscht.',
    'tournamentDelete.noDate': 'Kein Datum',
    'tournamentDelete.invalidDate': 'Ungültiges Datum',
    'tournamentDelete.unknown': 'Unbekannt',
    'tournamentDelete.select': 'Turnier auswählen',
    'tournamentDelete.choose': '-- Auswählen --',
    'tournamentDelete.deleting': 'Lösche...',
    'tournamentDelete.delete': 'Turnier löschen',
    'tournamentDelete.loadError': 'Fehler beim Laden der Turniere',
    'tournamentDelete.selectError': 'Bitte ein Turnier auswählen',
    'tournamentDelete.deleteError': 'Fehler beim Löschen des Turniers',

    // User Management
    'userMgmt.title': 'Benutzerverwaltung',
    'userMgmt.createUser': 'Neuen Benutzer anlegen',
    'userMgmt.editUser': 'Benutzer bearbeiten',
    'userMgmt.deleteUser': 'Benutzer löschen',
    'userMgmt.username': 'Benutzername',
    'userMgmt.password': 'Passwort',
    'userMgmt.role': 'Rolle',
    'userMgmt.active': 'Aktiv',
    'userMgmt.inactive': 'Inaktiv',
    'userMgmt.newUserBtn': '+ Neuer Benutzer',
    'userMgmt.newUser': 'Neuer Benutzer',
    'userMgmt.loading': 'Lade Benutzer...',
    'userMgmt.name': 'Name',
    'userMgmt.status': 'Status',
    'userMgmt.actions': 'Aktionen',
    'userMgmt.activate': 'Aktivieren',
    'userMgmt.deactivate': 'Deaktivieren',
    'userMgmt.noEmail': 'Keine E-Mail',
    'userMgmt.firstName': 'Vorname',
    'userMgmt.lastName': 'Nachname',
    'userMgmt.emailOptional': 'Email (optional)',
    'userMgmt.passwordHint': 'leer lassen um nicht zu ändern',
    'userMgmt.passwordReq': 'Mind. 8 Zeichen, 1 Groß-, 1 Kleinbuchstabe, 1 Ziffer',
    'userMgmt.passwordReqShort': 'Mindestens 8 Zeichen, 1 Großbuchstabe, 1 Kleinbuchstabe und 1 Ziffer',
    'userMgmt.allowedTypes': 'Erlaubte Turniertypen',
    'userMgmt.allowedTypesHint': 'Kein Typ ausgewählt = alle Typen erlaubt',
    'userMgmt.isActive': 'Benutzer ist aktiv',
    'userMgmt.createSuccess': 'Benutzer erfolgreich erstellt',
    'userMgmt.updateSuccess': 'Benutzer erfolgreich aktualisiert',
    'userMgmt.deleteSuccess': 'Benutzer erfolgreich gelöscht',
    'userMgmt.confirmDelete': 'Benutzer "{username}" wirklich löschen?',
    'userMgmt.confirmToggle': 'Benutzer "{username}" wirklich {action}?',
    'userMgmt.loadError': 'Fehler beim Laden der Benutzer',

    // Activity Log
    'activityLog.title': 'Aktivitäts-Log',
    'activityLog.subtitle': 'Protokoll aller Admin-Aktionen',
    'activityLog.clearAll': 'Alle Logs löschen',
    'activityLog.deleteDay': 'Diesen Tag löschen',
    'activityLog.confirmClearAll': 'Alle Log-Einträge werden unwiderruflich gelöscht.',
    'activityLog.confirmDeleteDay': 'Alle Einträge vom {date} werden unwiderruflich gelöscht.',
    'activityLog.noLogs': 'Keine Einträge vorhanden.',
    'activityLog.noLogsYet': 'Keine Log-Einträge vorhanden.',
    'activityLog.selectDay': 'Wähle einen Tag im Kalender aus',
    'activityLog.selectDayHint': 'Tage mit Logs sind durch einen Punkt markiert',
    'activityLog.entries': 'Einträge',
    'activityLog.entry': 'Eintrag',
    'activityLog.by': 'von',
    'activityLog.logsPresent': 'Logs vorhanden',
    'activityLog.errorLoadingDates': 'Fehler beim Laden der Log-Daten.',
    'activityLog.errorLoadingLogs': 'Fehler beim Laden der Logs.',
    'activityLog.errorClearAll': 'Fehler beim Löschen der Logs.',
    'activityLog.errorDeleteDay': 'Fehler beim Löschen der Tages-Logs.',
    'activityLog.hasLogs': '{day}. – Logs vorhanden',

    // System Settings
    'systemSettings.title': 'System-Einstellungen',
    'systemSettings.loading': 'Lade Einstellungen...',
    'systemSettings.subtitle': 'Hier kannst du globale Einstellungen für das gesamte Turniersystem anpassen. Diese Einstellungen gelten für alle Benutzer.',
    'systemSettings.general': 'Allgemein',
    'systemSettings.appName': 'Anwendungsname',
    'systemSettings.appNameHint': 'Name der Anwendung - wird als Browser-Titel angezeigt',
    'systemSettings.appNamePlaceholder': 'z.B. Padel Turnier',
    'systemSettings.branding': 'Branding / Logos',
    'systemSettings.mainLogo': 'Haupt-Logo',
    'systemSettings.mainLogoHint': 'Logo für Header und /present Footer (JPG, PNG, SVG, WebP, max. 5MB)',
    'systemSettings.sponsors': 'Sponsoren',
    'systemSettings.sponsorsHint': 'Mehrere Sponsoren mit Logo und optionalem Link. Werden rotierend angezeigt.',
    'systemSettings.showSponsor': 'Sponsor anzeigen',
    'systemSettings.showSponsorHint': 'Sponsor-Logo und "powered by" Banner anzeigen oder ausblenden',
    'systemSettings.sponsorVisible': 'Sponsor wird angezeigt',
    'systemSettings.sponsorHidden': 'Sponsor ist ausgeblendet',
    'systemSettings.sponsorRotation': 'Sponsor-Rotations-Dauer (Sekunden)',
    'systemSettings.sponsorRotationHint': 'Wie lange ein Sponsor-Logo auf der Hauptseite angezeigt wird, bevor zum nächsten gewechselt wird',
    'systemSettings.seconds160': 'Sekunden (1–60)',
    'systemSettings.seconds3120': 'Sekunden (3–120)',
    'systemSettings.appearance': 'Erscheinungsbild',
    'systemSettings.themeMode': 'Theme-Modus',
    'systemSettings.themeModeHint': 'Wähle, ob Benutzer das Theme selbst wählen können oder ob es erzwungen wird',
    'systemSettings.auto': 'Automatisch',
    'systemSettings.autoHint': 'Benutzer können zwischen Hell/Dunkel wechseln (Standard: System-Präferenz)',
    'systemSettings.forceLight': 'Immer Hell',
    'systemSettings.forceLightHint': 'Light Mode für alle Benutzer erzwingen (kein Toggle)',
    'systemSettings.forceDark': 'Immer Dunkel',
    'systemSettings.forceDarkHint': 'Dark Mode für alle Benutzer erzwingen (kein Toggle)',
    'systemSettings.presentationSection': 'Presentation View',
    'systemSettings.slideDuration': 'Slide-Dauer (Sekunden)',
    'systemSettings.slideDurationHint': 'Wie lange jeder Slide im Presentation View angezeigt wird, bevor automatisch zum nächsten gewechselt wird',
    'systemSettings.qrUrl': 'QR-Code Link',
    'systemSettings.qrUrlHint': 'URL, die der QR-Code im Presentation View verlinkt. Leer lassen für die automatische Startseite.',
    'systemSettings.qrUrlPlaceholder': 'z.B. https://turnier.example.com',
    'systemSettings.saving': 'Wird gespeichert...',
    'systemSettings.saveBtn': 'Einstellungen speichern',
    'systemSettings.unsaved': 'Nicht gespeicherte Änderungen',
    'systemSettings.saveSuccess': 'Einstellungen erfolgreich gespeichert',
    'systemSettings.loadError': 'Einstellungen konnten nicht geladen werden',
    'systemSettings.saveError': 'Fehler beim Speichern der Einstellungen',

    // Presentation View
    'presentation.noTournaments': 'Keine aktiven Turniere',
    'presentation.standings': 'Rangliste',
    'presentation.matches': 'Matches',
    'presentation.round': 'Runde',

    // Kontakt
    'kontakt.title': 'Kontakt',
    'kontakt.subtitle': 'Nehmen Sie Kontakt mit uns auf',
    'kontakt.text': 'Wir freuen uns über Ihre Nachricht. Nutzen Sie die folgenden Kontaktmöglichkeiten, um mit uns in Verbindung zu treten.',
    'kontakt.contactData': 'Kontaktdaten',
    'kontakt.company': 'Firma',
    'kontakt.owner': 'Inhaber',
    'kontakt.address': 'Adresse',
    'kontakt.email': 'E-Mail',
    'kontakt.inquiries': 'Anfragen',
    'kontakt.inquiriesText': 'Für Fragen zur Turnierverwaltung, technischen Support oder allgemeine Anfragen kontaktieren Sie uns bitte per E-Mail an',
    'kontakt.inquiriesText2': 'Wir bemühen uns, alle Anfragen schnellstmöglich zu beantworten.',
    'kontakt.privacy': 'Datenschutz',
    'kontakt.privacyText': 'Ihre Daten werden vertraulich behandelt und gemäß unserer',
    'kontakt.privacyLink': 'Datenschutzerklärung',
    'kontakt.privacyText2': 'verarbeitet.',

    // Tournament Schedule
    'schedule.loading': 'Lade Zeitplan...',
    'schedule.title': 'Zeitplan - Alle Spiele',
    'schedule.notAvailable': 'Zeitplanung nicht verfügbar',
    'schedule.notAvailableMsg': 'Für dieses Turnier wurde keine Zeitplanung konfiguriert.',
    'schedule.notAvailableHint': 'Die Zeitplanung kann nur beim Erstellen eines Gruppenphasen-Turniers aktiviert werden.',
    'schedule.notAvailableError': 'Zeitplanung nicht verfügbar für dieses Turnier',
    'schedule.time': 'Uhrzeit',
    'schedule.match': 'Spiel',
    'schedule.court': 'Court',
    'schedule.teams': 'Teams',
    'schedule.status': 'Status',
    'schedule.start': 'Start',
    'schedule.duration': 'Spieldauer',
    'schedule.break': 'Pause',
    'schedule.min': 'Min.',
    'schedule.noSchedule': 'Noch keine Spiele geplant',
    'schedule.loadError': 'Fehler beim Laden des Zeitplans',
    'schedule.completed': '✓ Beendet',
    'schedule.ongoing': '▶ Läuft',
    'schedule.open': '○ Offen',

    // Tournament Edit
    'edit.title': 'Turnier bearbeiten',
    'edit.selectTournament': 'Turnier auswählen *',
    'edit.chooseTournament': '-- Bitte Turnier auswählen --',
    'edit.loading': 'Lade Turnierdaten...',
    'edit.saveSuccess': 'Turnier erfolgreich aktualisiert!',
    'edit.saveError': 'Fehler beim Speichern',
    'edit.saving': 'Speichere...',
    'edit.saveBtn': 'Turnier aktualisieren',
    'edit.selectHint': 'Bitte wähle ein Turnier aus der Dropdown-Liste aus, um es zu bearbeiten.',
    'edit.players': 'Spieler',
    'edit.teamsAndPlayers': 'Teams & Spieler',
    'edit.assignGroup': 'Gruppe zuweisen',
    'edit.chooseGroup': '-- Gruppe wählen --',
    'edit.groupFull': '(voll)',
    'edit.assignGroupWarning': '⚠️ Bitte Gruppe zuweisen',
    'edit.formatNotChangeable': 'Turnierformat * (nicht änderbar)',
    'edit.consolationLocked': '⚠️ Trostrunden-Einstellung kann nach Draw-Generierung nicht mehr geändert werden',
    'edit.bestOfThreeLocked': '⚠️ Best-of-3 Einstellung kann nach Draw-Generierung nicht mehr geändert werden',
    'edit.playerN': 'Spieler {n}',
    'edit.player1': 'Spieler 1',
    'edit.player2': 'Spieler 2',
    'edit.placeholderPlayerN': 'Name Spieler {n}',
    'edit.placeholderPlayer1': 'Name Spieler 1',
    'edit.placeholderPlayer2': 'Name Spieler 2',

    // Tournament Create
    'create.title': 'Neues Turnier erstellen',
    'create.subtitle': 'Nach dem Erstellen können Sie Teams und Spieler hinzufügen.',
    'create.name': 'Turniername *',
    'create.date': 'Datum *',
    'create.format': 'Turnierformat *',
    'create.formatNote': '(nicht mehr änderbar nach Erstellung)',
    'create.formatWarning': '⚠️ Das Turnierformat kann nach der Erstellung nicht mehr geändert werden',
    'create.notAllowed': '(nicht erlaubt)',
    'create.numTeams': 'Anzahl Teams *',
    'create.numPlayers': 'Anzahl Spieler *',
    'create.numTeamsChoose': '-- Anzahl wählen --',
    'create.numGroups': 'Anzahl Gruppen *',
    'create.groupAssignment': 'Gruppenzuweisung *',
    'create.groupAuto': 'Automatisch zulosen (Random)',
    'create.groupManual': 'Manuell zuweisen',
    'create.teamsAdvance': 'Wie viele Teams kommen weiter? *',
    'create.drawMode': 'Auslosungs-Modus',
    'create.drawRandom': 'Zufällig (automatisch)',
    'create.drawManual': 'Manuell (Setzliste per Drag & Drop)',
    'create.scheduleSection': '⏰ Zeitplanung (Optional)',
    'create.startTime': 'Startzeit',
    'create.matchDuration': 'Spieldauer (Minuten)',
    'create.breakDuration': 'Pause zwischen Spielen (Minuten)',
    'create.consolation': 'Trostrunde aktivieren',
    'create.numRounds': 'Anzahl Runden *',
    'create.numRoundsAuto': 'Anzahl Runden',
    'create.numCourts': 'Anzahl Courts *',
    'create.courtNames': 'Court-Namen',
    'create.bestOfThree': 'Best of 3 (3 Gewinnsätze)',
    'create.showInPresentation': 'Im Presentation View anzeigen',
    'create.description': 'Beschreibung',
    'create.submitting': 'Erstelle...',
    'create.submit': 'Turnier erstellen',
    'create.success': 'Turnier erfolgreich erstellt! Sie können jetzt Teams/Spieler hinzufügen.',
    'create.error': 'Fehler beim Erstellen des Turniers',

    // Tooltips & Hilfstexte (Create/Edit)
    'create.tooltipName': 'Der Name wird überall im System angezeigt: auf dem Scoreboard, im Zeitplan und im Presentation View.',
    'create.tooltipDate': 'Der Turniertag. Wird in der Turnierübersicht und auf öffentlichen Ansichten angezeigt.',
    'create.tooltipFormat': 'KO: Wer verliert, scheidet aus. Schnell & spannend.\n\nMexicano: Paare werden nach jedem Spiel neu nach Punktestand gemischt.\n\nAmericano: Jeder spielt einmal mit und gegen jeden.\n\nGruppenphase + KO: Erst Rundenspiele in Gruppen, dann K.O.-Phase.\n\nKO mit Monrad-Platzierungen: K.O.-Baum mit Platzierungsspielen für alle Teams nach dem Monrad-System.',
    'create.tooltipNumTeamsMexicano': 'Anzahl der einzelnen Spieler. Muss durch 4 teilbar sein, da immer 4 Spieler gleichzeitig auf einem Court spielen.',
    'create.tooltipNumTeamsKoPlacement': 'KO mit Monrad-Platzierungen unterstützt genau 8 oder 16 Teams.',
    'create.tooltipNumTeams': 'Anzahl der Teams. Jedes Team besteht aus 2 Spielern.',
    'create.tooltipNumGroups': 'Teams werden gleichmäßig auf die Gruppen aufgeteilt.\n\nBeispiel: 16 Teams in 4 Gruppen = 4 Teams pro Gruppe.\n\nNur gerade Zahlen (2, 4, 6, 8) sind erlaubt.',
    'create.tooltipGroupAssignment': 'Automatisch: Teams werden per Zufallslos auf die Gruppen verteilt.\n\nManuell: Du kannst nach der Erstellung im \'Turnier bearbeiten\' jedes Team selbst einer Gruppe zuweisen.',
    'create.tooltipTeamsAdvance': 'Bestimmt, wie viele Teams aus jeder Gruppe in die K.O.-Phase einziehen.\n\nBeispiel: 4 Gruppen × 2 Teams = 8 Teams im Viertelfinale.\n\nMehr Teams = mehr Spielzeit für alle, aber längere K.O.-Runde.',
    'create.tooltipDrawMode': 'Zufällig: Teams werden automatisch per Los auf die Bracket-Slots verteilt.\n\nManuell: Du kannst nach der Erstellung selbst eine Setzliste per Drag & Drop festlegen – du bestimmst, wer gegen wen spielt.',
    'create.tooltipStartTime': 'Uhrzeit des ersten Spiels. Alle weiteren Spiele werden automatisch zeitlich danach eingeplant.\n\nOhne Startzeit gibt es keinen Zeitplan.',
    'create.tooltipMatchDuration': 'Maximale Dauer eines Spiels. Der nächste Slot auf dem Court beginnt erst nach dieser Zeit.\n\nEmpfehlung: 20–30 Minuten pro Spiel.',
    'create.tooltipBreakDuration': 'Wartezeit nach jedem Spiel, bevor ein Team oder ein Court wieder eingeplant wird.\n\nFür Auf- und Abwärmen, Teamwechsel etc. – 0 bedeutet keine Pflichtpause.',
    'create.tooltipConsolation': 'Verlierer der ersten K.O.-Runde spielen in einem separaten Baum weiter.\n\nSo spielen alle Teams mindestens 2 Spiele – kein Team fährt nach nur einer Niederlage nach Hause.',
    'create.tooltipNumRounds': 'Wie viele Runden gespielt werden. Nach jeder Runde werden neue Paare nach aktuellem Punktestand gebildet – die Stärksten spielen gegeneinander.\n\nMehr Runden = faireres Ergebnis, aber längeres Turnier.',
    'create.tooltipNumCourts': 'Auf wie vielen Courts gleichzeitig gespielt werden kann.\n\nMehr Courts = mehr parallele Spiele = kürzere Gesamtdauer des Turniers.',
    'create.tooltipBestOfThree': 'Jedes Spiel besteht aus bis zu 3 Sätzen. Wer zuerst 2 Sätze gewinnt, gewinnt das Spiel.\n\nBei Satzstand 1:1 entscheidet ein Tiebreak-Satz.',
    'create.tooltipShowInPresentation': 'Wenn aktiv, erscheint dieses Turnier auf dem öffentlichen TV-Display (/present) und rotiert dort automatisch.\n\nDeaktivieren für Testturniere oder wenn das Turnier noch nicht öffentlich sein soll.',
    'create.tooltipDescription': 'Optionaler Freitext – z.B. Kategorie, Level, Besonderheiten oder Hinweise für die Teilnehmer.',

    'create.placeholderName': 'z.B. x3 Padel Herbst Cup 2025',
    'create.placeholderNumTeams': 'z.B. 8',
    'create.placeholderNumGroups': 'z.B. 4',
    'create.placeholderStartTime': 'z.B. 14:00',
    'create.placeholderMatchDuration': 'z.B. 20',
    'create.placeholderBreakDuration': 'z.B. 5',
    'create.placeholderNumRounds': 'z.B. 5',
    'create.placeholderNumCourts': 'z.B. 2',
    'create.placeholderDescription': 'Optional: Kategorie, Level, Besonderheiten...',

    'create.helpNumTeamsMexicano': 'Anzahl der einzelnen Spieler (muss durch 4 teilbar sein)',
    'create.helpNumTeamsKoPlacement': 'KO mit Monrad-Platzierungen unterstützt 8 oder 16 Teams',
    'create.helpNumTeams': 'Anzahl der Teams (je 2 Spieler)',
    'create.helpNumGroups': 'Teams werden gleichmäßig auf die Gruppen aufgeteilt (nur gerade Zahlen)',
    'create.helpGroupAuto': 'Teams werden zufällig auf die Gruppen verteilt',
    'create.helpGroupManual': 'Sie können Teams manuell den Gruppen zuweisen (nach Erstellung im "Turnier bearbeiten")',
    'create.helpGroupManualEdit': 'Teams müssen manuell den Gruppen zugewiesen werden (siehe unten bei Teams)',
    'create.teamsAdvance2': 'Ersten 2 pro Gruppe (Viertelfinale bei 4 Gruppen)',
    'create.teamsAdvance3': 'Ersten 3 pro Gruppe (z.B. 12 Teams → Achtelfinale mit Byes)',
    'create.teamsAdvance4': 'Ersten 4 pro Gruppe (Achtelfinale bei 4 Gruppen)',
    'create.teamsAdvanceBestRunners': '6 Gruppensieger + 2 beste Zweitplatzierte (mit Platzierungsspielen)',
    'create.helpTeamsAdvanceBestRunners': 'Nur für 6 Gruppen: Gruppensieger + 2 beste Zweitplatzierte kommen ins Viertelfinale, alle anderen spielen um Platzierungen',
    'create.helpTeamsAdvance': 'Bestimmt wie viele Teams aus jeder Gruppe in die K.O.-Runde weiterkommen',
    'create.helpTeamsAdvanceLocked': '⚠️ Diese Einstellung kann nach der Turniererstellung nicht mehr geändert werden',
    'create.helpDrawManual': 'Nach der Erstellung kannst du im Bracket-Bereich die Setzliste per Drag & Drop festlegen',
    'create.helpDrawRandom': 'Teams werden beim Aktivieren des Turniers zufällig auf das Bracket verteilt',
    'create.helpStartTime': 'Wann startet das erste Spiel?',
    'create.helpMatchDuration': 'Maximale Dauer eines Spiels',
    'create.helpBreakDuration': 'Zeit für Teamwechsel, Aufwärmen etc.',
    'create.helpConsolation': 'Verlierer der ersten K.O.-Runde spielen in einem parallelen Trostrunden-Baum um Platzierungen weiter',
    'create.helpNumRounds': 'Wie viele Runden sollen gespielt werden?',
    'create.helpNumRoundsEdit': 'Nach dieser Anzahl Runden wird das Turnier automatisch abgeschlossen',
    'create.helpAmericanoRoundsAuto': 'automatisch: Spieler - 1',
    'create.helpAmericanoRounds': 'Bei Americano spielt jeder einmal mit und gegen jeden anderen. Das ergibt automatisch {n} Runden.',
    'create.helpBestOfThree': 'Bei Satzstand 1:1 wird ein Tiebreak-Satz gespielt',
    'create.helpBestOfThreeEdit': 'Spiele werden mit 3 Sätzen gespielt. Bei Satzstand 1:1 wird ein Tiebreak-Satz gespielt',
    'create.helpShowInPresentation': 'Turnier wird auf dem öffentlichen Display (/present) angezeigt',
    'edit.formatLocked': 'Das Turnierformat kann nach der Erstellung nicht mehr geändert werden',

    // Public Tournament View
    'publicView.loading': 'Lade aktive Turniere...',
    'publicView.noActive': 'Keine aktiven Turniere gefunden',
    'publicView.activateHint': 'Bitte aktiviere ein Turnier im Admin-Bereich',
    'publicView.date': 'Datum:',
    'publicView.selectTournament': 'Turnier auswählen:',
    'publicView.fullscreen': 'Vollbild',
    'publicView.exitFullscreen': 'Vollbild beenden',
    'publicView.autoRefresh': 'Seite aktualisiert sich automatisch alle 10 Sekunden',
    'publicView.groupPhase': 'Gruppenphase',
    'publicView.koRound': 'K.O.-Runde',
    'publicView.rankings': 'Rangliste',
    'publicView.matches': 'Spiele',
    'publicView.rank': 'Rang',
    'publicView.player': 'Spieler',
    'publicView.points': 'Punkte',
    'publicView.wins': 'Siege',
    'publicView.losses': 'Niederl.',
    'publicView.sets': 'Sätze',
    'publicView.diff': 'Dif.',

    // Footer
    'footer.impressum': 'Impressum',
    'footer.datenschutz': 'Datenschutz',
    'footer.kontakt': 'Kontakt',
  },

  en: {
    // Navigation
    'nav.currentTournaments': 'Current Tournaments',
    'nav.presentationView': 'Presentation View',
    'nav.pastTournaments': 'Past Tournaments',
    'nav.adminLogin': 'Admin Login',
    'nav.adminArea': 'Admin Area',
    'nav.myProfile': 'My Profile',
    'nav.bracket': 'Bracket / Enter Results',
    'nav.bracketShort': 'Results',
    'nav.editTournament': 'Edit Tournament',
    'nav.editShort': 'Edit',
    'nav.createTournament': 'Create Tournament',
    'nav.createShort': 'Create',
    'nav.deleteTournament': 'Delete Tournament',
    'nav.deleteShort': 'Delete',
    'nav.userManagement': 'User Management',
    'nav.usersShort': 'Users',
    'nav.systemSettings': 'System Settings',
    'nav.settingsShort': 'Settings',
    'nav.activityLog': 'Activity Log',
    'nav.logout': 'Logout',
    'nav.menu': 'Menu',
    'nav.close': 'Close',
    'nav.tournaments': 'Tournaments',
    'nav.archive': 'Archive',
    'nav.presentation': 'Presentation',
    'nav.login': 'Login',

    // Common
    'common.loading': 'Loading...',
    'common.loadingData': 'Loading data...',
    'common.error': 'Error',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.create': 'Create',
    'common.close': 'Close',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.confirm': 'Confirm',
    'common.back': 'Back',
    'common.teams': 'Teams',
    'common.courts': 'Courts',
    'common.finished': 'Finished',
    'common.open': 'Open',
    'common.bye': 'Bye',
    'common.round': 'Round',
    'common.note': 'Note',
    'common.notePlaceholder': 'e.g. Retired due to injury...',
    'common.points': 'Points',
    'common.rank': 'Rank',
    'common.name': 'Name',
    'common.date': 'Date',
    'common.noData': 'No data available.',
    'common.poweredBy': 'powered by',
    'common.activate': 'Activate',
    'common.deactivate': 'Deactivate',
    'common.remove': 'Remove',

    // Admin Bracket View
    'admin.loadingTournament': 'Loading tournament data...',
    'admin.searchTournament': '🔍 Search tournament:',
    'admin.searchPlaceholder': 'Search by name or date...',
    'admin.selectTournament': 'Select tournament:',
    'admin.selectDefault': '-- Please select a tournament --',
    'admin.activeTournaments': '🟢 Active tournaments',
    'admin.inactiveTournaments': '⚪ Inactive tournaments',
    'admin.finishTournament': '🏆 Finish tournament & show rankings',
    'admin.finishing': 'Finishing...',
    'admin.saveResult': 'Save result',
    'admin.saveCourtOnly': 'Save time/court only',
    'admin.saveCourt': 'Save time/court',
    'admin.tournamentCompleted': 'Tournament finished',
    'admin.tournamentFinished': 'Tournament completed',
    'admin.generating': 'Generating...',
    'admin.generateNextRound': 'Generate next round ({n})',
    'admin.createBracket': 'Create bracket',
    'admin.creatingBracket': 'Creating bracket…',
    'admin.seedTeamsRemaining': '{n} team(s) left to seed',
    'admin.matchFinished': '✓ Finished',
    'admin.matchRunning': '▶ Running',
    'admin.matchOpen': '○ Open',
    'admin.editCourtTime': 'Edit court / time',
    'admin.editModalTitle': 'Court / Time / Note',
    'admin.courtLabel': '🏟️ Court',
    'admin.courtPlaceholder': 'e.g. Court 1',
    'admin.timeLabel': '⏰ Start time',
    'admin.endTime': 'End time:',
    'admin.noteLabel': '📝 Note (admins only)',
    'admin.set1': 'Set 1',
    'admin.set2': 'Set 2',
    'admin.tiebreak': 'Tiebreak',
    'admin.tiebreakHint': 'Tiebreak only if sets are tied 1:1',
    'admin.onlyIfTied': 'only if sets are tied 1:1',
    'admin.pointsTeam1': 'Points team 1',
    'admin.pointsTeam2': 'Points team 2',
    'admin.errorEnterBothScores': 'Please enter both scores',
    'admin.errorEnterSets': 'Please enter at least set 1 and set 2',
    'admin.noDate': 'No date',
    'admin.invalidDate': 'Invalid date',
    'admin.timeHeader': 'Time',
    'admin.matchHeader': 'Match',
    'admin.statusHeader': 'Status',
    'admin.tipClickMatch': '💡 Tip: Click on a match to jump to the group phase and enter the result.',

    // Tournament type labels
    'type.ko': 'KO Tournament',
    'type.groups': 'Group Phase',
    'type.mexicano': 'Mexicano',
    'type.americano': 'Americano',
    'type.ko_placement': 'KO+Monrad',

    // Round names
    'round.final': 'Final',
    'round.semifinal': 'Semifinal',
    'round.quarterfinal': 'Quarterfinal',
    'round.thirdPlace': 'Third Place Match',
    'round.winnerOf': 'Winner',
    'round.loserOf': 'Loser',

    // Current Tournament page
    'currentTournament.title': 'Current Tournaments',
    'currentTournament.loading': 'Loading tournament data...',
    'currentTournament.noTournaments': 'No active tournaments at the moment.',
    'currentTournament.loadError': 'Error loading tournaments.',

    // Past Tournaments page
    'pastTournaments.title': 'Past Tournaments',
    'pastTournaments.loading': 'Loading tournament data...',
    'pastTournaments.noTournaments': 'No past tournaments saved yet.',
    'pastTournaments.loadError': 'Error loading tournaments.',

    // Tournament Detail page
    'tournamentDetail.loading': 'Loading tournament data...',
    'tournamentDetail.notFound': 'Tournament not found.',
    'tournamentDetail.loadError': 'Error loading tournament data.',
    'tournamentDetail.details': 'Tournament Details',
    'tournamentDetail.backToOverview': '← Back to Overview',
    'tournamentDetail.tab.matches': 'Matches',
    'tournamentDetail.tab.standings': 'Standings',
    'tournamentDetail.tab.teams': 'Teams',
    'tournamentDetail.set': 'Set',
    'tournamentDetail.finished': '✓ Finished',
    'tournamentDetail.done': '✓ Done',
    'tournamentDetail.inTournament': 'In Tournament',
    'tournamentDetail.standings': 'Rankings',
    'tournamentDetail.liveStandings': 'Live Standings',
    'tournamentDetail.currentPlacements': 'Current Placements',
    'tournamentDetail.finalRankings': '🏆 Final Rankings',
    'tournamentDetail.mainBracket': '🏆 Main Bracket',
    'tournamentDetail.places5to8': '5th–8th Place',
    'tournamentDetail.places9to16': '9th–16th Place',
    'tournamentDetail.placement': 'Placement',
    'tournamentDetail.rank': 'Rank',
    'tournamentDetail.player': 'Player / Team',
    'tournamentDetail.wins': 'W',
    'tournamentDetail.losses': 'L',
    'tournamentDetail.draws': 'D',
    'tournamentDetail.pts': 'Pts.',
    'tournamentDetail.sets': 'Sets',
    'tournamentDetail.diff': 'Diff.',
    'tournamentDetail.setsWon': 'Sets+',
    'tournamentDetail.setsLost': 'Sets-',
    'tournamentDetail.setsDiff': 'Set diff.',
    'tournamentDetail.gamesWon': 'Games+',
    'tournamentDetail.gamesLost': 'Games-',
    'tournamentDetail.gamesDiff': 'Game diff.',
    'tournamentDetail.noTeams': 'No teams.',
    'tournamentDetail.noMatches': 'No matches yet.',
    'tournamentDetail.knockoutPhase': 'Final Rounds',
    'tournamentDetail.placementMatches': 'Placement Matches',
    'tournamentDetail.schedule': '⏰ View Schedule',
    'tournamentDetail.viewSchedule': '⏰ View Schedule',
    'tournamentDetail.realtime': 'Live updates active',

    // Admin Login
    'adminLogin.title': 'Admin Login',
    'adminLogin.username': 'Username',
    'adminLogin.password': 'Password',
    'adminLogin.submit': 'Log in',
    'adminLogin.loading': 'Logging in...',
    'adminLogin.error': 'Login failed. Please check your credentials.',

    // User Profile
    'userProfile.title': 'My Profile',
    'userProfile.username': 'Username',
    'userProfile.firstName': 'First name',
    'userProfile.lastName': 'Last name',
    'userProfile.email': 'Email',
    'userProfile.role': 'Role',
    'userProfile.createdAt': 'Account created on',
    'userProfile.editProfile': 'Edit Profile',
    'userProfile.changePassword': 'Change Password (optional)',
    'userProfile.passwordHint': 'Leave these fields empty if you do not want to change your password.',
    'userProfile.newPassword': 'New Password',
    'userProfile.confirmPassword': 'Confirm Password',
    'userProfile.passwordMismatch': 'Passwords do not match',
    'userProfile.saveSuccess': 'Profile updated successfully',
    'userProfile.loading': 'Loading profile...',
    'role.user': 'User',
    'role.tournament_admin': 'Tournament Admin',
    'role.full_admin': 'Full Admin',

    // Tournament Create/Edit
    'tournamentForm.createTitle': 'Create New Tournament',
    'tournamentForm.editTitle': 'Edit Tournament',
    'tournamentForm.name': 'Tournament Name',
    'tournamentForm.type': 'Tournament Type',
    'tournamentForm.date': 'Date',
    'tournamentForm.teams': 'Number of Teams',
    'tournamentForm.courts': 'Number of Courts',
    'tournamentForm.description': 'Description',
    'tournamentForm.active': 'Active',
    'tournamentForm.submit': 'Create',
    'tournamentForm.update': 'Save',

    // Tournament Delete
    'tournamentDelete.title': 'Delete Tournament',
    'tournamentDelete.confirm': 'Really delete?',
    'tournamentDelete.success': 'Tournament deleted successfully.',
    'tournamentDelete.noDate': 'No date',
    'tournamentDelete.invalidDate': 'Invalid date',
    'tournamentDelete.unknown': 'Unknown',
    'tournamentDelete.select': 'Select Tournament',
    'tournamentDelete.choose': '-- Choose --',
    'tournamentDelete.deleting': 'Deleting...',
    'tournamentDelete.delete': 'Delete Tournament',
    'tournamentDelete.loadError': 'Failed to load tournaments',
    'tournamentDelete.selectError': 'Please select a tournament',
    'tournamentDelete.deleteError': 'Failed to delete tournament',

    // User Management
    'userMgmt.title': 'User Management',
    'userMgmt.createUser': 'Create New User',
    'userMgmt.editUser': 'Edit User',
    'userMgmt.deleteUser': 'Delete User',
    'userMgmt.username': 'Username',
    'userMgmt.password': 'Password',
    'userMgmt.role': 'Role',
    'userMgmt.active': 'Active',
    'userMgmt.inactive': 'Inactive',
    'userMgmt.newUserBtn': '+ New User',
    'userMgmt.newUser': 'New User',
    'userMgmt.loading': 'Loading users...',
    'userMgmt.name': 'Name',
    'userMgmt.status': 'Status',
    'userMgmt.actions': 'Actions',
    'userMgmt.activate': 'Activate',
    'userMgmt.deactivate': 'Deactivate',
    'userMgmt.noEmail': 'No email',
    'userMgmt.firstName': 'First name',
    'userMgmt.lastName': 'Last name',
    'userMgmt.emailOptional': 'Email (optional)',
    'userMgmt.passwordHint': 'leave blank to keep unchanged',
    'userMgmt.passwordReq': 'Min. 8 chars, 1 upper, 1 lower, 1 digit',
    'userMgmt.passwordReqShort': 'At least 8 characters, 1 uppercase, 1 lowercase and 1 digit',
    'userMgmt.allowedTypes': 'Allowed tournament types',
    'userMgmt.allowedTypesHint': 'No type selected = all types allowed',
    'userMgmt.isActive': 'User is active',
    'userMgmt.createSuccess': 'User created successfully',
    'userMgmt.updateSuccess': 'User updated successfully',
    'userMgmt.deleteSuccess': 'User deleted successfully',
    'userMgmt.confirmDelete': 'Really delete user "{username}"?',
    'userMgmt.confirmToggle': 'Really {action} user "{username}"?',
    'userMgmt.loadError': 'Error loading users',

    // Activity Log
    'activityLog.title': 'Activity Log',
    'activityLog.subtitle': 'Record of all admin actions',
    'activityLog.clearAll': 'Clear all logs',
    'activityLog.deleteDay': 'Delete this day',
    'activityLog.confirmClearAll': 'All log entries will be permanently deleted.',
    'activityLog.confirmDeleteDay': 'All entries from {date} will be permanently deleted.',
    'activityLog.noLogs': 'No entries.',
    'activityLog.noLogsYet': 'No log entries yet.',
    'activityLog.selectDay': 'Select a day in the calendar',
    'activityLog.selectDayHint': 'Days with logs are marked with a dot',
    'activityLog.entries': 'entries',
    'activityLog.entry': 'entry',
    'activityLog.by': 'by',
    'activityLog.logsPresent': 'Logs available',
    'activityLog.errorLoadingDates': 'Error loading log dates.',
    'activityLog.errorLoadingLogs': 'Error loading logs.',
    'activityLog.errorClearAll': 'Error deleting logs.',
    'activityLog.errorDeleteDay': 'Error deleting day logs.',
    'activityLog.hasLogs': '{day}. – Logs available',

    // System Settings
    'systemSettings.title': 'System Settings',
    'systemSettings.loading': 'Loading settings...',
    'systemSettings.subtitle': 'Here you can adjust global settings for the entire tournament system. These settings apply to all users.',
    'systemSettings.general': 'General',
    'systemSettings.appName': 'Application name',
    'systemSettings.appNameHint': 'Name of the application - shown as the browser title',
    'systemSettings.appNamePlaceholder': 'e.g. Padel Tournament',
    'systemSettings.branding': 'Branding / Logos',
    'systemSettings.mainLogo': 'Main logo',
    'systemSettings.mainLogoHint': 'Logo for the header and /present footer (JPG, PNG, SVG, WebP, max. 5MB)',
    'systemSettings.sponsors': 'Sponsors',
    'systemSettings.sponsorsHint': 'Multiple sponsors with logo and optional link. Displayed in rotation.',
    'systemSettings.showSponsor': 'Show sponsor',
    'systemSettings.showSponsorHint': 'Show or hide the sponsor logo and "powered by" banner',
    'systemSettings.sponsorVisible': 'Sponsor is visible',
    'systemSettings.sponsorHidden': 'Sponsor is hidden',
    'systemSettings.sponsorRotation': 'Sponsor rotation duration (seconds)',
    'systemSettings.sponsorRotationHint': 'How long a sponsor logo is shown on the main page before switching to the next one',
    'systemSettings.seconds160': 'seconds (1–60)',
    'systemSettings.seconds3120': 'seconds (3–120)',
    'systemSettings.appearance': 'Appearance',
    'systemSettings.themeMode': 'Theme mode',
    'systemSettings.themeModeHint': 'Choose whether users can select the theme themselves or whether it is forced',
    'systemSettings.auto': 'Automatic',
    'systemSettings.autoHint': 'Users can switch between light/dark (default: system preference)',
    'systemSettings.forceLight': 'Always light',
    'systemSettings.forceLightHint': 'Force light mode for all users (no toggle)',
    'systemSettings.forceDark': 'Always dark',
    'systemSettings.forceDarkHint': 'Force dark mode for all users (no toggle)',
    'systemSettings.presentationSection': 'Presentation View',
    'systemSettings.slideDuration': 'Slide duration (seconds)',
    'systemSettings.slideDurationHint': 'How long each slide in the Presentation View is shown before automatically switching to the next',
    'systemSettings.qrUrl': 'QR Code link',
    'systemSettings.qrUrlHint': 'URL that the QR code in the Presentation View links to. Leave empty to use the automatic homepage.',
    'systemSettings.qrUrlPlaceholder': 'e.g. https://tournament.example.com',
    'systemSettings.saving': 'Saving...',
    'systemSettings.saveBtn': 'Save settings',
    'systemSettings.unsaved': 'Unsaved changes',
    'systemSettings.saveSuccess': 'Settings saved successfully',
    'systemSettings.loadError': 'Could not load settings',
    'systemSettings.saveError': 'Error saving settings',

    // Presentation View
    'presentation.noTournaments': 'No active tournaments',
    'presentation.standings': 'Standings',
    'presentation.matches': 'Matches',
    'presentation.round': 'Round',

    // Kontakt
    'kontakt.title': 'Contact',
    'kontakt.subtitle': 'Get in touch with us',
    'kontakt.text': 'We look forward to hearing from you. Use the following contact options to get in touch.',
    'kontakt.contactData': 'Contact details',
    'kontakt.company': 'Company',
    'kontakt.owner': 'Owner',
    'kontakt.address': 'Address',
    'kontakt.email': 'E-Mail',
    'kontakt.inquiries': 'Inquiries',
    'kontakt.inquiriesText': 'For questions about tournament management, technical support or general inquiries, please contact us by email at',
    'kontakt.inquiriesText2': 'We strive to answer all inquiries as quickly as possible.',
    'kontakt.privacy': 'Privacy',
    'kontakt.privacyText': 'Your data will be treated confidentially and processed in accordance with our',
    'kontakt.privacyLink': 'Privacy Policy',
    'kontakt.privacyText2': '.',

    // Tournament Schedule
    'schedule.loading': 'Loading schedule...',
    'schedule.title': 'Schedule - All Matches',
    'schedule.notAvailable': 'Schedule not available',
    'schedule.notAvailableMsg': 'No schedule was configured for this tournament.',
    'schedule.notAvailableHint': 'Schedules can only be activated when creating a group-phase tournament.',
    'schedule.notAvailableError': 'Schedule not available for this tournament',
    'schedule.time': 'Time',
    'schedule.match': 'Match',
    'schedule.court': 'Court',
    'schedule.teams': 'Teams',
    'schedule.status': 'Status',
    'schedule.start': 'Start',
    'schedule.duration': 'Duration',
    'schedule.break': 'Break',
    'schedule.min': 'min.',
    'schedule.noSchedule': 'No matches scheduled yet',
    'schedule.loadError': 'Error loading schedule',
    'schedule.completed': '✓ Finished',
    'schedule.ongoing': '▶ In progress',
    'schedule.open': '○ Open',

    // Tournament Edit
    'edit.title': 'Edit Tournament',
    'edit.selectTournament': 'Select Tournament *',
    'edit.chooseTournament': '-- Please select a tournament --',
    'edit.loading': 'Loading tournament data...',
    'edit.saveSuccess': 'Tournament updated successfully!',
    'edit.saveError': 'Error saving',
    'edit.saving': 'Saving...',
    'edit.saveBtn': 'Update Tournament',
    'edit.selectHint': 'Please select a tournament from the dropdown to edit it.',
    'edit.players': 'Players',
    'edit.teamsAndPlayers': 'Teams & Players',
    'edit.assignGroup': 'Assign group',
    'edit.chooseGroup': '-- Choose group --',
    'edit.groupFull': '(full)',
    'edit.assignGroupWarning': '⚠️ Please assign a group',
    'edit.formatNotChangeable': 'Tournament Format * (not changeable)',
    'edit.consolationLocked': '⚠️ Consolation bracket setting cannot be changed after draw generation',
    'edit.bestOfThreeLocked': '⚠️ Best-of-3 setting cannot be changed after draw generation',
    'edit.playerN': 'Player {n}',
    'edit.player1': 'Player 1',
    'edit.player2': 'Player 2',
    'edit.placeholderPlayerN': 'Player {n} name',
    'edit.placeholderPlayer1': 'Player 1 name',
    'edit.placeholderPlayer2': 'Player 2 name',

    // Tournament Create
    'create.title': 'Create New Tournament',
    'create.subtitle': 'After creating, you can add teams and players.',
    'create.name': 'Tournament Name *',
    'create.date': 'Date *',
    'create.format': 'Tournament Format *',
    'create.formatNote': '(cannot be changed after creation)',
    'create.formatWarning': '⚠️ The tournament format cannot be changed after creation',
    'create.notAllowed': '(not allowed)',
    'create.numTeams': 'Number of Teams *',
    'create.numPlayers': 'Number of Players *',
    'create.numTeamsChoose': '-- Choose count --',
    'create.numGroups': 'Number of Groups *',
    'create.groupAssignment': 'Group Assignment *',
    'create.groupAuto': 'Automatic draw (random)',
    'create.groupManual': 'Manual assignment',
    'create.teamsAdvance': 'How many teams advance? *',
    'create.drawMode': 'Draw mode',
    'create.drawRandom': 'Random (automatic)',
    'create.drawManual': 'Manual (seeding via drag & drop)',
    'create.scheduleSection': '⏰ Scheduling (Optional)',
    'create.startTime': 'Start time',
    'create.matchDuration': 'Match duration (minutes)',
    'create.breakDuration': 'Break between matches (minutes)',
    'create.consolation': 'Enable consolation bracket',
    'create.numRounds': 'Number of Rounds *',
    'create.numRoundsAuto': 'Number of Rounds',
    'create.numCourts': 'Number of Courts *',
    'create.courtNames': 'Court Names',
    'create.bestOfThree': 'Best of 3 (3 winning sets)',
    'create.showInPresentation': 'Show in Presentation View',
    'create.description': 'Description',
    'create.submitting': 'Creating...',
    'create.submit': 'Create Tournament',
    'create.success': 'Tournament created successfully! You can now add teams/players.',
    'create.error': 'Error creating tournament',

    // Tooltips & help texts (Create/Edit)
    'create.tooltipName': 'The name is shown everywhere in the system: on the scoreboard, in the schedule, and in the Presentation View.',
    'create.tooltipDate': 'The tournament day. Shown in the tournament overview and on public views.',
    'create.tooltipFormat': 'KO: Losers are eliminated. Fast & exciting.\n\nMexicano: Pairs are re-matched after each round based on current standings.\n\nAmericano: Everyone plays once with and against everyone.\n\nGroup stage + KO: Round-robin in groups, then knockout phase.\n\nKO with Monrad placements: KO bracket with placement matches for all teams using the Monrad system.',
    'create.tooltipNumTeamsMexicano': 'Number of individual players. Must be divisible by 4, as 4 players always play on one court at a time.',
    'create.tooltipNumTeamsKoPlacement': 'KO with Monrad placements supports exactly 8 or 16 teams.',
    'create.tooltipNumTeams': 'Number of teams. Each team consists of 2 players.',
    'create.tooltipNumGroups': 'Teams are evenly distributed across groups.\n\nExample: 16 teams in 4 groups = 4 teams per group.\n\nOnly even numbers (2, 4, 6, 8) are allowed.',
    'create.tooltipGroupAssignment': 'Automatic: Teams are randomly drawn into groups.\n\nManual: You can assign each team to a group yourself after creation in \'Edit Tournament\'.',
    'create.tooltipTeamsAdvance': 'Determines how many teams from each group advance to the knockout phase.\n\nExample: 4 groups × 2 teams = 8 teams in the quarter-finals.\n\nMore teams = more playing time for everyone, but a longer knockout round.',
    'create.tooltipDrawMode': 'Random: Teams are automatically drawn into bracket slots.\n\nManual: After creation, you can set the seeding via drag & drop – you decide who plays whom.',
    'create.tooltipStartTime': 'Time of the first match. All subsequent matches are automatically scheduled after this.\n\nWithout a start time, no schedule is generated.',
    'create.tooltipMatchDuration': 'Maximum duration of a match. The next slot on the court starts only after this time.\n\nRecommendation: 20–30 minutes per match.',
    'create.tooltipBreakDuration': 'Waiting time after each match before a team or court is scheduled again.\n\nFor warm-up, team changes, etc. – 0 means no mandatory break.',
    'create.tooltipConsolation': 'Losers of the first knockout round continue in a separate bracket.\n\nThis way all teams play at least 2 matches – no team goes home after just one loss.',
    'create.tooltipNumRounds': 'How many rounds will be played. After each round, new pairs are formed based on current standings – the strongest play each other.\n\nMore rounds = fairer result, but longer tournament.',
    'create.tooltipNumCourts': 'How many courts can be played on simultaneously.\n\nMore courts = more parallel matches = shorter total tournament duration.',
    'create.tooltipBestOfThree': 'Each match consists of up to 3 sets. The first to win 2 sets wins the match.\n\nAt 1:1, a tiebreak set decides.',
    'create.tooltipShowInPresentation': 'When active, this tournament appears on the public TV display (/present) and rotates there automatically.\n\nDisable for test tournaments or if the tournament should not yet be public.',
    'create.tooltipDescription': 'Optional free text – e.g. category, level, special features, or notes for participants.',

    'create.placeholderName': 'e.g. x3 Padel Autumn Cup 2025',
    'create.placeholderNumTeams': 'e.g. 8',
    'create.placeholderNumGroups': 'e.g. 4',
    'create.placeholderStartTime': 'e.g. 14:00',
    'create.placeholderMatchDuration': 'e.g. 20',
    'create.placeholderBreakDuration': 'e.g. 5',
    'create.placeholderNumRounds': 'e.g. 5',
    'create.placeholderNumCourts': 'e.g. 2',
    'create.placeholderDescription': 'Optional: Category, Level, Special features...',

    'create.helpNumTeamsMexicano': 'Number of individual players (must be divisible by 4)',
    'create.helpNumTeamsKoPlacement': 'KO with Monrad placements supports 8 or 16 teams',
    'create.helpNumTeams': 'Number of teams (2 players each)',
    'create.helpNumGroups': 'Teams are evenly distributed across groups (even numbers only)',
    'create.helpGroupAuto': 'Teams are randomly distributed across groups',
    'create.helpGroupManual': 'You can manually assign teams to groups (after creation in "Edit Tournament")',
    'create.helpGroupManualEdit': 'Teams must be manually assigned to groups (see teams section below)',
    'create.teamsAdvance2': 'Top 2 per group (quarter-finals with 4 groups)',
    'create.teamsAdvance3': 'Top 3 per group (e.g. 12 teams → round of 16 with byes)',
    'create.teamsAdvance4': 'Top 4 per group (round of 16 with 4 groups)',
    'create.teamsAdvanceBestRunners': '6 group winners + 2 best runners-up (with placement matches)',
    'create.helpTeamsAdvanceBestRunners': 'For 6 groups only: group winners + 2 best runners-up advance to quarter-finals, all others play placement matches',
    'create.helpTeamsAdvance': 'Determines how many teams from each group advance to the knockout round',
    'create.helpTeamsAdvanceLocked': '⚠️ This setting cannot be changed after tournament creation',
    'create.helpDrawManual': 'After creation, you can set the seeding via drag & drop in the bracket area',
    'create.helpDrawRandom': 'Teams are randomly seeded into the bracket when the tournament is activated',
    'create.helpStartTime': 'When does the first match start?',
    'create.helpMatchDuration': 'Maximum duration of a match',
    'create.helpBreakDuration': 'Time for team changes, warm-up, etc.',
    'create.helpConsolation': 'Losers of the first knockout round continue in a parallel consolation bracket for placements',
    'create.helpNumRounds': 'How many rounds should be played?',
    'create.helpNumRoundsEdit': 'After this number of rounds the tournament is automatically completed',
    'create.helpAmericanoRoundsAuto': 'automatic: players - 1',
    'create.helpAmericanoRounds': 'In Americano, each player plays once with and against every other player. This automatically results in {n} rounds.',
    'create.helpBestOfThree': 'At a set score of 1:1, a tiebreak set is played',
    'create.helpBestOfThreeEdit': 'Matches are played with 3 sets. At a score of 1:1, a tiebreak set is played',
    'create.helpShowInPresentation': 'Tournament is shown on the public display (/present)',
    'edit.formatLocked': 'The tournament format cannot be changed after creation',

    // Public Tournament View
    'publicView.loading': 'Loading active tournaments...',
    'publicView.noActive': 'No active tournaments found',
    'publicView.activateHint': 'Please activate a tournament in the admin area',
    'publicView.date': 'Date:',
    'publicView.selectTournament': 'Select tournament:',
    'publicView.fullscreen': 'Fullscreen',
    'publicView.exitFullscreen': 'Exit fullscreen',
    'publicView.autoRefresh': 'Page auto-refreshes every 10 seconds',
    'publicView.groupPhase': 'Group Phase',
    'publicView.koRound': 'K.O. Round',
    'publicView.rankings': 'Rankings',
    'publicView.matches': 'Matches',
    'publicView.rank': 'Rank',
    'publicView.player': 'Player',
    'publicView.points': 'Points',
    'publicView.wins': 'Wins',
    'publicView.losses': 'Losses',
    'publicView.sets': 'Sets',
    'publicView.diff': 'Diff.',

    // Footer
    'footer.impressum': 'Legal Notice',
    'footer.datenschutz': 'Privacy Policy',
    'footer.kontakt': 'Contact',
  }
};

export default translations;
